import { CommonModule, CurrencyPipe, NgFor, NgIf } from '@angular/common'
import { Component, inject, Input } from '@angular/core'
import { EmployeeSalary } from '../../../../store/employee-salary/employee-salary.state'
import { User } from '../../../../store/auth/auth.state'
import dayjs from 'dayjs'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-monthly-salary-modal',
  imports: [NgIf, NgFor, CurrencyPipe, CommonModule],
  templateUrl: './monthly-salary-modal.component.html',
  styleUrl: './monthly-salary-modal.component.scss'
})
export class MonthlySalaryModalComponent {
  private activeModal = inject(NgbActiveModal)
  @Input() employee!: User
  @Input() employeeSalaryDetails!: EmployeeSalary | null

  get totalDaysInPayrollPeriod(): number {
    const today = dayjs()
    const effectiveFrom = dayjs(this.employeeSalaryDetails?.effectiveFrom, 'DD-MMM-YYYY')

    const totalDaysInMonth = today.daysInMonth()

    if (effectiveFrom.isSame(today, 'month') && effectiveFrom.isSame(today, 'year')) {
      const effectiveDay = effectiveFrom.date()
      return totalDaysInMonth - (effectiveDay - 1)
    } else return totalDaysInMonth
  }

  get monthlyTotalEarnings(): number {
    if (!this.employeeSalaryDetails) return 0
    const monthlyBasic = this.employeeSalaryDetails.salaryData.basic / 12
    const monthlyHra = this.employeeSalaryDetails.salaryData.hra / 12
    const monthlySpecialAllowance = this.employeeSalaryDetails.salaryData.specialAllowance / 12
    const otherComponents = this.employeeSalaryDetails.salaryData.otherComponents
      .filter(item => item.componentType !== 'customDeductions')
      .map(item => (item.employerContribution ?? 0) / 12)
    let otherEarnings = 0
    if (otherComponents.length > 0) {
      otherEarnings = otherComponents.reduce((acc, curr) => acc + curr, 0)
    }
    return monthlyBasic + monthlyHra + monthlySpecialAllowance + otherEarnings
  }

  get monthlyTotalDeductions(): number {
    if (!this.employeeSalaryDetails) return 0
    const pf = this.employeeSalaryDetails.salaryData.pf / 12
    const otherComponents = this.employeeSalaryDetails.salaryData.otherComponents
      .filter(item => item.componentType === 'customDeductions')
      .map(item => (item.employeeContribution ?? 0) / 12)
    let otherDeductions = 0
    if (otherComponents.length > 0) {
      otherDeductions = otherComponents.reduce((acc, curr) => acc + curr, 0)
    }
    return pf + otherDeductions
  }

  onClose(): void {
    this.activeModal.close()
  }
}
